/**
 * Aplicación web Directorio del Ayuntamiento de Zamora.
 * 
 * Desarrollo e implementación: Jaime León Pereira.
 * Ingeniero Informático de la Unidad TIC.
 */
import React, { useState } from "react";
import EntityTable from "../common/EntityTable";

const DepartamentosTable = () => {
  // Estado del departamento y persona seleccionados
  const [departamentoSeleccionado, setDepartamentoSeleccionado] = useState(null);
  const [personaSeleccionada, setPersonaSeleccionada] = useState(null);

  // Función para "volver atrás"
  const handleBack = () => {
    if (personaSeleccionada) {
      setPersonaSeleccionada(null); // volver al detalle del departamento
    } else if (departamentoSeleccionado) {
      setDepartamentoSeleccionado(null); // volver a la lista de departamentos
    }
  };

  // Si hay persona seleccionada, mostramos su detalle usando PersonasTable
  if (personaSeleccionada) {
    return (
      <div className="container mt-4">
        <div className="row h-100">
          <div className="col-12 d-flex justify-content-center align-items-center" style={{ height: "100%" }}>
            <div 
              className="card shadow-lg h-100"
            >
              <div className="card-body d-flex flex-column align-items-center m-1">
                
                <h5 className="mb-3 text-center">
                  <strong>
                    {personaSeleccionada.nombre} {personaSeleccionada.apellido1} {personaSeleccionada.apellido2}
                  </strong>
                </h5>

                <img
                  src={
                    personaSeleccionada.fotoUrl
                      ? `${process.env.REACT_APP_URL}${personaSeleccionada.fotoUrl}`
                      : `${process.env.REACT_APP_URL}/uploads/default.png`
                  }
                  alt="Foto de la persona"
                  style={{
                    width: "120px",
                    height: "120px",
                    objectFit: "cover",
                    borderRadius: "50%",
                    marginBottom: "1rem",
                    boxShadow: "4px 4px 12px rgba(0,0,0,0.2)",
                  }}
                />

                <ul className="list-group w-100 text-start">
                  <li className="list-group-item"><strong>Cargo:</strong> {personaSeleccionada.cargo ?? "-"}</li>
                  <li className="list-group-item"><strong>Email:</strong> {personaSeleccionada.email}</li>
                  <li className="list-group-item"><strong>Teléfono:</strong> {personaSeleccionada.telefono ?? "-"}</li>
                  <li className="list-group-item"><strong>Extensión:</strong> {personaSeleccionada.extension ?? "-"}</li>
                  <li className="list-group-item"><strong>Edificio:</strong> {personaSeleccionada.edificio?.nombre ?? "-"}</li>   
                </ul>

                <button className="btn btn-primary mt-2" onClick={handleBack}>
		  <i className="bi bi-arrow-left me-2"></i>
                  Volver al departamento
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }


  // Si hay departamento seleccionado, mostramos su detalle con lista de personas
  if (departamentoSeleccionado) {

    const personasOrdenadas = departamentoSeleccionado.personas
    ? [...departamentoSeleccionado.personas].sort((a, b) =>
        `${a.nombre} ${a.apellido1} ${a.apellido2}`.localeCompare(
          `${b.nombre} ${b.apellido1} ${b.apellido2}`,
          "es",
          { sensitivity: "base" }
        )
      )
    : [];
    
    return (
      <div>
        <div className="card shadow p-3">
          <h5 className="card-title fw-semibold mb-2 text-center">{departamentoSeleccionado.nombre}</h5>
          <div
            style={{
              width: "140px",
              height: "3px",
              backgroundColor: "#0d6efd",
              margin: "0 auto",
              borderRadius: "2px"
            }}
          />
          <h6 style={{margin: "10px"}}> Personal:</h6>
          
          {personasOrdenadas.length > 0 ? (
            <div className="card" style={{ height: "52vh"}}>
              <div className="card-body flex-grow-1 overflow-auto" style={{backgroundColor: "rgba(78, 77, 77, 0.1)"}}>
                <div className="row">
                  {personasOrdenadas.map((p) => (
                    <div className="col-12 col-md-6" key={p.id}>
                    <button
                      key={p.id}
                      className="list-group-item list-group-item-action d-flex flex-column justify-content-center align-items-center text-center m-1 shadow bg-white"
                      style={{
                        borderRadius: "12px",
                        padding: "12px"
                      }}
                      onClick={() => setPersonaSeleccionada(p)}
                    >
                      {/* Nombre y apellidos en negrita */}
                      <span className="fw-bold">
                        {p.nombre} {p.apellido1} {p.apellido2}
                      </span>

                      {/* Departamento debajo, más pequeño y sin negrita */}
                      <span className="text-muted" style={{ fontSize: "0.9rem" }}>
                        {p.cargo || ""}
                      </span>
                    </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : (
            <p>No hay personal asignado</p>
          )}

          <button className="btn btn-primary mt-2 mb-2" onClick={handleBack}>
	    <i className="bi bi-arrow-left me-2"></i>
            Volver a departamentos
          </button>
        </div>
        
      </div>
    );
  }

  // Si no hay nada seleccionado, mostramos la lista de departamentos
  return (
    <EntityTable
      endpoint="/departamentos"
      title="Departamentos"
      showImage={false}
      renderItem={(d) => (
        <button
          key={d.id}
          className="list-group-item list-group-item-action d-flex justify-content-center align-items-center text-center fw-bold bg-white shadow"
          style={{
            borderRadius: "12px",
            padding: "12px"
          }}
          onClick={() => setDepartamentoSeleccionado(d)}
        >
          {d.nombre}
        </button>
          )}
        />
      );
    };

export default DepartamentosTable;

